
export const FEMALE_CATEGORIES = [
    { id: 'necklace', label: 'Necklace' },
    { id: 'haaram', label: 'Haaram' },
    { id: 'choker', label: 'Choker' },
    { id: 'ring', label: 'Ring' },
    { id: 'couple rings', label: 'Couple Rings' },
    { id: 'earring', label: 'Earrings / Jhumka' },
    { id: 'pendant', label: 'Pendant' },
    { id: 'vaddanam', label: 'Vaddanam / Hip Chain' },
    { id: 'bangle', label: 'Bangle / Bracelet' },
    { id: 'maang tikka', label: 'Maang Tikka' },
    { id: 'nose ring', label: 'Nose Ring (Nath)' },
    { id: 'bajuband', label: 'Bajuband (Armlet)' }
];

export const MALE_CATEGORIES = [
    { id: 'ring', label: 'Ring' },
    { id: 'couple rings', label: 'Couple Rings' },
    { id: 'haar', label: 'Haar (Grand Necklace)' },
    { id: 'pendant', label: 'Pendant' },
    { id: 'kada', label: 'Kada (Bracelet)' },
    { id: 'brooch', label: 'Brooch' },
    { id: 'sherwani buttons', label: 'Sherwani Buttons' },
    { id: 'kalgi', label: 'Kalgi (Turban Pin)' },
    { id: 'bracelet', label: 'Bracelet' }
];

export const PREMIUM_BACKGROUNDS = [
    { id: 'White Marble', color: '#f8f9fa', textColor: 'text-slate-600' },
    { id: 'Black Velvet', color: '#1a1a1a', textColor: 'text-white' },
    { id: 'Beige Stone', color: '#e6dace', textColor: 'text-stone-800' },
    { id: 'Midnight Silk', color: '#0f172a', textColor: 'text-white' },
    { id: 'Rose Satin', color: '#fff1f2', textColor: 'text-rose-900' },
    { id: 'Deep Emerald', color: '#064e3b', textColor: 'text-white' }
];

export const MODES: ('female' | 'male' | 'studio')[] = ['female', 'male', 'studio'];
